import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { IReviewers } from "@/Washouts/types/PayrollClosing/CommissionCycleClosingReviewers";

type SubAvatarCardProps = {
	title?: string;
	content?: IReviewers[];
};

export default function SubAvatarCard(props: Readonly<SubAvatarCardProps>) {
	return (
		<Card className="max-w-[218px] !shadow-card-gray !rounded-t-[0px] !rounded-b-[10px] ml-[41px]">
			<Grid container>
				<div className="font-medium font-montserrat text-[13px] text-gray-text ml-[26px] mt-[7px]">{props.title ?? ""}</div>
				<div className="pl-[23px] pb-[10px] text-left pt-[4px] pr-[23px] text-[12px] flex border-[0px] border-black">
					<Grid container>
						{props?.content?.map((entry, i) => {
							return (
								<Grid item key={`${entry._id}_${i}`} sx={{ minWidth: "75px" }}>
									<div className="font-medium font-sans text-[12px] text-gray-text mt-[-2px] ml-[4px]">
										{entry.review?.statusSetBy?.fullName}
									</div>
								</Grid>
							);
						})}
					</Grid>
				</div>
			</Grid>
		</Card>
	);
}
